import React from 'react';
import SubmitButton from '../SubmitButton/SubmitButton'; // Предполагаем, что у вас уже есть компонент SubmitButton
import './FormButtonsOrg.css';
const FormButtonsOrg = ({
  isFormChanged,
  isFormValid,
  isLoadingFormData,
  onSave,
  onCancel,
  onDelete,
  onSync,
  deleteDisabled = false,
  isLoadingRemove,
}) => {
  return (
    <div className='my-orgs-tab__form_org-buttons'>
      {/* Кнопка "Сохранить" */}
      <SubmitButton
        text='Сохранить'
        disabled={!isFormChanged || !isFormValid}
        type='submit'
        onClick={onSave}
        className='my-orgs-tab__button'
        isLoading={isLoadingFormData}
        id='save'
      />

      {/* Кнопка "Отменить" */}
      <SubmitButton
        text='Отменить'
        disabled={!isFormChanged}
        type='button'
        onClick={onCancel}
        className='my-orgs-tab__button my-orgs-tab__button_cancel'
      />

      {/* Кнопка "Удалить" */}
      <SubmitButton
        text='Удалить'
        disabled={deleteDisabled}
        type='button'
        onClick={onDelete}
        className='my-orgs-tab__button my-orgs-tab__button_delete'
        isLoading={isLoadingRemove}
        id='delete'
      />
      <SubmitButton
        id='sync'
        type='button'
        onClick={onSync}
        text='Синхронизация'
        className='my-orgs-tab__button'
      />
    </div>
  );
};

export default FormButtonsOrg;
